import NavigationTabsPageSubHeader from "../components/layout/NavigationTabsPageSubHeader";
import SystemSettingsLayout, { SystemSettingsMicroservicesSectionLayout, SystemSettingsUsersSectionLayout } from "../layouts/SystemSettingsLayout";
import { NavigationTabs } from "../components/navigation";
import { GraphSubscriptionsPage, IntroducerManagementPage, UserDelegatesPage, UsersPage } from "../pages/settings";
import {
    GraphMicroserviceManagementPage,
    MicroserviceManagementPage,
    ClientAuthMicroserviceManagementPage,
    ClientSearchMicroserviceManagementPage,
    ClientReportsMicroserviceManagementPage,
    IdentityMicroserviceManagementPage,
    RecommendationsMicroserviceManagementPage,
    AssetManagementMicroserviceManagementPage,
    AuditLogsMicroserviceManagementPage,
    CampaignManagementMicroserviceManagementPage,
    ClientDetailsMicroserviceManagementPage,
    ClientProjectsMicroserviceManagementPage,
    ClientProjectSummaryMicroserviceManagementPage,
    ClientReviewsMicroserviceManagementPage,
    HeadOfficeAdminMicroserviceManagementPage,
    NavigationMicroserviceManagementPage,
    RemindersMicroserviceManagementPage,
    ValuationsMicroserviceManagementPage,
    ClientFactFindMicroserviceManagementPage,
    MessagingMicroserviceManagementPage,
    ProductsMicroserviceManagementPage
} from "../pages/settings/microservice-management";

const SettingsRoutes = [{
    path: '/settings/*',
    pathBase: '/settings',
    defaultRoute: 'users',
    roles: ['sys_admin_access'],
    element: SystemSettingsLayout,
    children: [
        {
            path: 'users',
            pathBase: '/settings/users',
            defaultRoute: '',
            icon: 'fa-user-cog',
            label: 'Users & Teams',
            roles: [],
            element: SystemSettingsUsersSectionLayout,
            children: [
                {
                    path: '',
                    label: 'Users',
                    icon: 'fa-user',
                    element: UsersPage
                },
                {
                    path: 'delegates',
                    label: 'Delegate Access',
                    icon: 'fa-user-friends',
                    element: UserDelegatesPage
                },
                {
                    path: 'subscriptions',
                    label: 'Graph Subscriptions',
                    icon: 'fa-rss',
                    element: GraphSubscriptionsPage
                },
            ]
        },
        {
            path: 'introducers',
            pathBase: '/settings/introducers',
            icon: 'fa-handshake',
            label: 'Introducer Management',
            roles: [],
            element: IntroducerManagementPage
        },
        {
            path: 'microservices',
            pathBase: '/settings/microservices',
            icon: 'fa-server',
            label: 'Microservice Management',
            roles: [],
            element: SystemSettingsMicroservicesSectionLayout,
            children: [
                {
                    path: '',
                    label: 'Summary',
                    icon: 'fa-columns',
                    element: MicroserviceManagementPage
                },
                {
                    path: 'asset-management',
                    label: 'Asset Management',
                    icon: 'fa-magnifying-glass-chart',
                    element: AssetManagementMicroserviceManagementPage
                },
                {
                    path: 'audit-logs',
                    label: 'Audit Logs',
                    icon: 'fa-list',
                    element: AuditLogsMicroserviceManagementPage
                },
                {
                    path: 'campagin-management',
                    label: 'Campaign Management',
                    icon: 'fa-tents',
                    element: CampaignManagementMicroserviceManagementPage
                },
                {
                    path: 'client-auth',
                    label: 'Client Auth',
                    icon: 'fa-user-shield',
                    element: ClientAuthMicroserviceManagementPage
                },
                {
                    path: 'client-details',
                    label: 'Client Details',
                    icon: 'fa-users',
                    element: ClientDetailsMicroserviceManagementPage
                },
                {
                    path: 'client-projects',
                    label: 'Client Projects',
                    icon: 'fa-diagram-project',
                    element: ClientProjectsMicroserviceManagementPage
                },
                {
                    path: 'client-projects-summary',
                    label: 'Client Projects Summary',
                    icon: 'fa-diagram-project',
                    element: ClientProjectSummaryMicroserviceManagementPage
                },
                {
                    path: 'client-reviews',
                    label: 'Client Reviews',
                    icon: 'fa-book-open',
                    element: ClientReviewsMicroserviceManagementPage
                },
                {
                    path: 'client-search',
                    label: 'Client Search',
                    icon: 'fa-search',
                    element: ClientSearchMicroserviceManagementPage
                },
                {
                    path: 'client-reports',
                    label: 'Client Reports',
                    icon: 'fa-file-lines',
                    element: ClientReportsMicroserviceManagementPage
                },
                {
                    path: 'client-factfind',
                    label: 'Fact Find',
                    icon: 'fa-file-pen',
                    element: ClientFactFindMicroserviceManagementPage
                },
                {
                    path: 'head-office-admin',
                    label: 'Head Office Admin',
                    icon: 'fa-house',
                    element: HeadOfficeAdminMicroserviceManagementPage
                },
                {
                    path: 'identity-users',
                    label: 'Identity',
                    icon: 'fa-users',
                    element: IdentityMicroserviceManagementPage
                },
                {
                    path: 'messaging',
                    label: 'Messaging',
                    icon: 'fa-comments',
                    element: MessagingMicroserviceManagementPage
                },
                {
                    path: 'microsoft-graph',
                    label: 'Microsoft Graph',
                    icon: 'fa-file-upload',
                    element: GraphMicroserviceManagementPage
                },
                {
                    path: 'navigation',
                    label: 'Navigation',
                    icon: 'fa-list',
                    element: NavigationMicroserviceManagementPage
                },
                {
                    path: 'products',
                    label: 'Products',
                    icon: 'fa-table-list',
                    element: ProductsMicroserviceManagementPage
                },
                {
                    path: 'recommendations',
                    label: 'Recommendations',
                    icon: 'fa-file-circle-check',
                    element: RecommendationsMicroserviceManagementPage
                },
                {
                    path: 'reminders',
                    label: 'Reminders',
                    icon: 'fa-list-check',
                    element: RemindersMicroserviceManagementPage
                },
                {
                    path: 'valuations',
                    label: 'Valuations',
                    icon: 'fa-sterling-sign',
                    element: ValuationsMicroserviceManagementPage
                },
            ]
        }
    ]
}];

export const SystemSettingsRouteTabs = () => <NavigationTabs pathBase={SettingsRoutes[0].pathBase} options={SettingsRoutes[0]} />

export const SystemSettingsMicroservicesRouteTabs = () => (
    <NavigationTabsPageSubHeader
        top="91"
        pathBase="/settings/microservices"
        options={SettingsRoutes[0].children[2]}
    />
);

export const SystemSettingsUsersRouteTabs = () => (
    <NavigationTabsPageSubHeader
        top="91"
        pathBase="/settings/users"
        options={SettingsRoutes[0].children[0]}
    />
);

export default SettingsRoutes;